export default [
    {
        path: '/error-404',
        name: 'error-404',
        component: () => import('@/views/error/Error404.vue'),
        meta: {
            title: 'i18n:',
            layout: 'full',
            resource: 'Publico',
            action: 'ver-publico',
        },
    },
    {
        path: '/login',
        name: 'auth-login',
        component: () => import('@/views/pages/authentication/Login.vue'),
        meta: {
            title: 'i18n:',
            layout: 'full',
            resource: 'Publico',
            action: 'ver-publico',
            redirectIfLoggedIn: true,
        },
    },
    {
        path: '/verificar-firma',
        name: 'verificar-firma',
        component: () => import('@/views/pages/controlCalidad/firmas/VerificarFirma.vue'),
        meta: {
            title: 'i18n:',
            layout: 'full',
            resource: 'Publico',
            action: 'ver-publico',
            redirectIfLoggedIn: false,
        },
    },
    {
        path: '/olvido-contrasenia',
        name: 'auth-forgot-password',
        component: () => import('@/views/pages/authentication/ForgotPassword.vue'),
        meta: {
            title: 'i18n:',
            layout: 'full',
            resource: 'Publico',
            action: 'ver-publico',
            redirectIfLoggedIn: true,
        },
    },
    {
        path: '/restablecer-contrasenia',
        name: 'auth-reset-password',
        component: () => import('@/views/pages/authentication/ResetPassword.vue'),
        meta: {
            title: 'i18n:',
            layout: 'full',
            resource: 'Publico',
            action: 'ver-publico',
            redirectIfLoggedIn: true,
        },
    },
    {
        path: '/no-autorizado',
        name: 'not-authorized',
        component: () => import('@/views/pages/errores/NotAuthorized.vue'),
        meta: {
            title: 'i18n:',
            layout: 'full',
            resource: 'Publico',
            action: 'ver-publico',
        },
    },
    {
        path: '/error',
        name: 'error',
        component: () => import('@/views/pages/errores/Error.vue'),
        meta: {
            title: 'i18n:',
            layout: 'full',
            resource: 'Publico',
            action: 'ver-publico',
        },
    },
    {
        path: '/privacy-policy',
        name: 'privacy-policy',
        component: () => import('@/views/legal/PrivacyPolicy.vue'),
        meta: {
            title: 'i18n:',
            layout: 'full',
            resource: 'Publico',
            action: 'ver-publico',
        },
    },
    {
        path: '/eliminar-cuenta',
        name: 'eliminar-cuenta',
        component: () => import('@/views/legal/EliminarCuenta.vue'),
        meta: {
            title: 'i18n:',
            layout: 'full',
            resource: 'Publico',
            action: 'ver-publico',
        },
    },
]
